import { components } from 'react-select';
import type { GroupBase, MultiValueProps } from 'react-select';

/* custom MultiValue component passed to react-select */
export function Selection<Option = unknown, IsMulti extends boolean = true>({
  children,
  ...props
}: MultiValueProps<Option, IsMulti, GroupBase<Option>>) {
  return (
    <components.MultiValue<Option, IsMulti, GroupBase<Option>> {...props} getStyles={() => ({})}>
      {children}
    </components.MultiValue>
  );
}
